import { motion } from "framer-motion";

/**
 * Reusable hero header for sub-pages.
 * Props: eyebrow ("02 — Services"), title, subtitle
 */
export default function PageHero({ eyebrow, title, titleAccent, subtitle, children }) {
  return (
    <section className="relative pt-32 pb-16 md:pt-40 md:pb-24 px-6 md:px-12 border-b border-white/10">
      <div className="max-w-[1600px] mx-auto">
        {eyebrow && (
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-[11px] tracking-[0.32em] uppercase text-white/50 mb-6"
          >
            {eyebrow}
          </motion.div>
        )}
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.05 }}
          className="font-anton uppercase text-5xl sm:text-6xl md:text-8xl leading-[0.9] tracking-tight max-w-5xl"
        >
          {title}{" "}
          {titleAccent && <span className="text-[#2A5BFF]">{titleAccent}</span>}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.25 }}
            className="mt-8 text-white/70 text-lg md:text-xl font-light leading-relaxed max-w-2xl"
          >
            {subtitle}
          </motion.p>
        )}
        {children && <div className="mt-10">{children}</div>}
      </div>
    </section>
  );
}
